export enum OperationTypeEnum {
    Send = 1,
    CheckPortability = 2,
    ChangePassword = 3,
    CheckCredit = 4
}